// App Version Configuration
// Update this file when releasing new versions


export const APP_VERSION = '1.0.1';
export const APP_BUILD_DATE = '2026-02-01';

export const CHANGELOG = [
  {
    version: '1.0.1',
    date: '2026-02-01',
    changes: [
      'Forgot password now sends a 6-digit OTP to registered email and requires OTP to reset password.',
      'Reset password UI updated to accept OTP.',
      'Improved feedback and error messages for password reset.',
    ],
    type: 'patch',
  },
  {
    version: '1.0.0',
    date: '2026-02-01',
    changes: [
      'Initial release with full e-commerce functionality',
      'Added user authentication (login, register, password reset)',
      'Product catalog with categories and search',
      'Shopping cart with multi-day rental support',
      'Razorpay payment integration',
      'Order tracking system',
      'User profile management',
      'In-app notifications for order updates',
      'Feedback system for user suggestions',
      'Mobile-responsive design with bottom navigation',
    ],
    type: 'major',
  },
];

// Helper function to get latest changes
export const getLatestChanges = () => {
  return CHANGELOG[0] || null;
};

// Helper function to get all changes
export const getAllChanges = () => {
  return CHANGELOG;
};

const versionConfig = {
  version: APP_VERSION,
  buildDate: APP_BUILD_DATE,
  changelog: CHANGELOG,
};

export default versionConfig;
